import React from "react";
import { useController } from "react-hook-form";

const Textarea = (props) => {
	const {
		card,
		getValue,
		control,
		placeholder,
		name,
		validation,
		readonly,
		required,
		showCount,
		maxLength,
	} = props;

	const {
		field: { onChange, value },
	} = useController({
		name,
		control,
		rules: {
			required:
				required === true ? "필수 입력 사항 입니다." : required === null ? " " : required,
			...validation,
		},
	});

	return (
		<>
			<textarea
				name={name}
				className={`c__textarea f__item `}
				placeholder={placeholder}
				value={value}
				onChange={(e) => {
					e.target.value.length <= (maxLength || 500) && onChange(e.target.value);
					getValue(e.target.value, card);
				}}
				readOnly={readonly}
			/>
			{showCount && (
				<span className="character-length">
					{value && value.length ? value.length : 0}/{maxLength}
				</span>
			)}
		</>
	);
};

export default Textarea;
